import { publicApiUrl } from '../lib/serviceUrls';
import { useEffect, useState } from 'react';

export const DEFAULT_LATEST_VIDEO_URL = 'https://www.youtube.com/embed/TZiBFw2Py8k';
const LATEST_VIDEO_API_URL =
  process.env.REACT_APP_LATEST_VIDEO_API_URL || publicApiUrl('/latest-video');

// One fetch per page load, shared across every mount of the hook.
let latestVideoPromise = null;
let cachedVideoUrl = null;

function loadLatestVideoUrl() {
  if (cachedVideoUrl) return Promise.resolve(cachedVideoUrl);
  if (latestVideoPromise) return latestVideoPromise;

  latestVideoPromise = (async () => {
    try {
      const response = await fetch(LATEST_VIDEO_API_URL, {
        headers: { Accept: 'application/json' },
      });
      if (!response.ok) return DEFAULT_LATEST_VIDEO_URL;

      const data = await response.json();
      const nextUrl = typeof data?.embedUrl === 'string' ? data.embedUrl.trim() : '';
      if (!nextUrl.startsWith('https://www.youtube.com/embed/')) return DEFAULT_LATEST_VIDEO_URL;

      cachedVideoUrl = nextUrl;
      return nextUrl;
    } catch (_error) {
      // Keep the hardcoded fallback when the API is unavailable; allow a retry on the next mount.
      latestVideoPromise = null;
      return DEFAULT_LATEST_VIDEO_URL;
    }
  })();

  return latestVideoPromise;
}

export default function useLatestVideoUrl() {
  const [videoUrl, setVideoUrl] = useState(cachedVideoUrl || DEFAULT_LATEST_VIDEO_URL);

  useEffect(() => {
    let isCancelled = false;

    loadLatestVideoUrl().then((url) => {
      if (!isCancelled && url) setVideoUrl(url);
    });

    return () => {
      isCancelled = true;
    };
  }, []);

  return videoUrl;
}
